import api from 'api';

interface RecoverTasksResult {
  recovered_count: number;
  task_ids: string[];
}

export interface IFailedTasksFilter {
  errorType: string;
  errorMessage?: string;
}

export default function bulkResetFailedTasks(
  projectId: string,
  workflowId: string,
  filter?: IFailedTasksFilter,
): Promise<RecoverTasksResult> {
  const searchParams = new URLSearchParams();
  if (filter) {
    searchParams.set('error_type', filter.errorType);
    if (filter.errorMessage !== undefined) searchParams.set('error_message', filter.errorMessage);
  }
  return api.post(`projects/${projectId}/workflows/${workflowId}/tasks/bulk-reset-failed`, { searchParams }).json();
}
